import { useEffect, useState } from 'react';

const matches = (query) =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(query).matches;

// Whether the screen matches a CSS media query, kept up to date as it resizes.
const useMediaQuery = (query) => {
  const [isMatch, setIsMatch] = useState(() => matches(query));

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;

    const mediaQuery = window.matchMedia(query);
    const handleChange = (event) => setIsMatch(event.matches);

    setIsMatch(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [query]);

  return isMatch;
};

export default useMediaQuery;
